import {
  Component
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule
} from '@angular/forms';

import {
  MatSelectModule
} from '@angular/material/select';

import {
  MatFormFieldModule
} from '@angular/material/form-field';

import {
  MatOptionModule
} from '@angular/material/core';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector: 'app-line-cell-select',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatOptionModule
  ],

  templateUrl:'./line-cell-select.component.html'
})
export class LineCellSelectComponent
extends LineCellBaseComponent {
}